/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import { Button, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import cookieBannerStyle from "./cookieBannerStyle";
import { Link } from "react-router";
import CookieModal from "./CookieModal";
import { useCookieConsent } from "../../provider/CookieConsent/CookieConsentProvider";

const CookieBanner = () => {
  const { allowAll, denyAll, showCookieBanner } = useCookieConsent();
  const [isConfigureOpen, setIsConfigureOpen] = useState(false);
  const [isSelectionMade, setIsSelectionMade] = useState(false);


  if (isSelectionMade || !showCookieBanner) {
    return null;
  }

  return (
    <Paper sx={cookieBannerStyle.banner}>
      <Grid container spacing={4} sx={{
        alignItems: "center"
      }}>
        <Grid
          size={{
            md: 8,
            xs: 12
          }}>
          <Typography
            sx={[{
              fontWeight: "bold"
            }, cookieBannerStyle.headline]}>
            Schutz Ihrer Daten
          </Typography>
          <p>
            Für ein optimales Website-Erlebnis nutzen wir Cookies und ähnliche Technologien, um personalisierte Inhalte zu zeigen, Funktionen anzubieten und
            Statistiken zu erheben. Ein Klick auf "Akzeptieren" erlaubt uns diese Datenverarbeitung sowie die Weitergabe an Drittanbieter gemäß unserer
            Datenschutzerklärung. Personalisieren Sie ihre Cookie-Einstellungen (dies ist auch nachträglich jederzeit im Bereich Datenschutz möglich) oder
            klicken Sie auf "Ablehnen", wenn Sie nicht möchten, dass wir Cookies zu diesem Zweck verwenden. Weitere Informationen finden Sie unter{" "}
            <Link to={"/datenschutz"}>Datenschutzerklärung</Link>, <Link to={"/agb"}>AGB</Link> oder <Link to={"/impressum"}>Impressum</Link>.
          </p>
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 12
          }}>
          <Grid container spacing={2} sx={{
            justifyContent: "space-between"
          }}>
            <Grid
              size={{
                md: 4,
                xs: 6
              }}>
              <Button fullWidth onClick={() => setIsConfigureOpen(true)} color={"primary"}>
                Konfigurieren
              </Button>
            </Grid>
            <Grid
              size={{
                lg: 4,
                xs: 6
              }}>
              <Button
                fullWidth
                onClick={() => {
                  setIsSelectionMade(true);
                  denyAll();
                }}
                color={"primary"}
              >
                Ablehnen
              </Button>
            </Grid>
            <Grid
              size={{
                lg: 4,
                xs: 12
              }}>
              <Button
                fullWidth
                onClick={() => {
                  setIsSelectionMade(true);
                  allowAll();
                }}
                variant={"contained"}
                color={"primary"}
              >
                Akzeptieren
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <CookieModal isSelectionMade={isSelectionMade} setIsSelectionMade={setIsSelectionMade} open={isConfigureOpen} setIsConfigureOpen={setIsConfigureOpen} />
    </Paper>
  );
};

export default CookieBanner;
